import { render, staticRenderFns } from "./approvalsecondstage-component.vue?vue&type=template&id=e3ffae9e"
import script from "./approvalsecondstage-component.vue?vue&type=script&lang=ts"
export * from "./approvalsecondstage-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports